module.exports = __webpack_public_path__ + "static/home_static_section-46eccef5cdd01cf26c1dd85164d70be5.svg";